/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ProtectedImport } from './routes/_protected'
import { Route as IndexImport } from './routes/index'

// Create Virtual Routes

const ProtectedSettingsLazyImport = createFileRoute('/_protected/settings')()
const ProtectedGuideLazyImport = createFileRoute('/_protected/guide')()
const ProtectedSyncIndexLazyImport = createFileRoute('/_protected/sync/')()
const ProtectedSyncOrdersLazyImport = createFileRoute(
  '/_protected/sync/orders',
)()
const ProtectedSyncSyncIdLazyImport = createFileRoute(
  '/_protected/sync/$syncId',
)()
const ProtectedSyncCategoryCategoryIdLazyImport = createFileRoute(
  '/_protected/sync/category/$categoryId',
)()

// Create/Update Routes

const ProtectedRoute = ProtectedImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedSettingsLazyRoute = ProtectedSettingsLazyImport.update({
  path: '/settings',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/settings.lazy').then((d) => d.Route),
)

const ProtectedGuideLazyRoute = ProtectedGuideLazyImport.update({
  path: '/guide',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/guide.lazy').then((d) => d.Route),
)

const ProtectedSyncIndexLazyRoute = ProtectedSyncIndexLazyImport.update({
  path: '/sync/',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/sync/index.lazy').then((d) => d.Route),
)

const ProtectedSyncOrdersLazyRoute = ProtectedSyncOrdersLazyImport.update({
  path: '/sync/orders',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/sync/orders.lazy').then((d) => d.Route),
)

const ProtectedSyncSyncIdLazyRoute = ProtectedSyncSyncIdLazyImport.update({
  path: '/sync/$syncId',
  getParentRoute: () => ProtectedRoute,
} as any).lazy(() =>
  import('./routes/_protected/sync/$syncId.lazy').then((d) => d.Route),
)

const ProtectedSyncCategoryCategoryIdLazyRoute =
  ProtectedSyncCategoryCategoryIdLazyImport.update({
    path: '/sync/category/$categoryId',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/sync/category/$categoryId.lazy').then(
      (d) => d.Route,
    ),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImport
      parentRoute: typeof rootRoute
    }
    '/_protected/guide': {
      id: '/_protected/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof ProtectedGuideLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/settings': {
      id: '/_protected/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof ProtectedSettingsLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/sync/$syncId': {
      id: '/_protected/sync/$syncId'
      path: '/sync/$syncId'
      fullPath: '/sync/$syncId'
      preLoaderRoute: typeof ProtectedSyncSyncIdLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/sync/orders': {
      id: '/_protected/sync/orders'
      path: '/sync/orders'
      fullPath: '/sync/orders'
      preLoaderRoute: typeof ProtectedSyncOrdersLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/sync/': {
      id: '/_protected/sync/'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof ProtectedSyncIndexLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/sync/category/$categoryId': {
      id: '/_protected/sync/category/$categoryId'
      path: '/sync/category/$categoryId'
      fullPath: '/sync/category/$categoryId'
      preLoaderRoute: typeof ProtectedSyncCategoryCategoryIdLazyImport
      parentRoute: typeof ProtectedImport
    }
  }
}

// Create and export the route tree

interface ProtectedRouteChildren {
  ProtectedGuideLazyRoute: typeof ProtectedGuideLazyRoute
  ProtectedSettingsLazyRoute: typeof ProtectedSettingsLazyRoute
  ProtectedSyncSyncIdLazyRoute: typeof ProtectedSyncSyncIdLazyRoute
  ProtectedSyncOrdersLazyRoute: typeof ProtectedSyncOrdersLazyRoute
  ProtectedSyncIndexLazyRoute: typeof ProtectedSyncIndexLazyRoute
  ProtectedSyncCategoryCategoryIdLazyRoute: typeof ProtectedSyncCategoryCategoryIdLazyRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedGuideLazyRoute: ProtectedGuideLazyRoute,
  ProtectedSettingsLazyRoute: ProtectedSettingsLazyRoute,
  ProtectedSyncSyncIdLazyRoute: ProtectedSyncSyncIdLazyRoute,
  ProtectedSyncOrdersLazyRoute: ProtectedSyncOrdersLazyRoute,
  ProtectedSyncIndexLazyRoute: ProtectedSyncIndexLazyRoute,
  ProtectedSyncCategoryCategoryIdLazyRoute:
    ProtectedSyncCategoryCategoryIdLazyRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteWithChildren
  '/guide': typeof ProtectedGuideLazyRoute
  '/settings': typeof ProtectedSettingsLazyRoute
  '/sync/$syncId': typeof ProtectedSyncSyncIdLazyRoute
  '/sync/orders': typeof ProtectedSyncOrdersLazyRoute
  '/sync': typeof ProtectedSyncIndexLazyRoute
  '/sync/category/$categoryId': typeof ProtectedSyncCategoryCategoryIdLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof ProtectedRouteWithChildren
  '/guide': typeof ProtectedGuideLazyRoute
  '/settings': typeof ProtectedSettingsLazyRoute
  '/sync/$syncId': typeof ProtectedSyncSyncIdLazyRoute
  '/sync/orders': typeof ProtectedSyncOrdersLazyRoute
  '/sync': typeof ProtectedSyncIndexLazyRoute
  '/sync/category/$categoryId': typeof ProtectedSyncCategoryCategoryIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_protected/guide': typeof ProtectedGuideLazyRoute
  '/_protected/settings': typeof ProtectedSettingsLazyRoute
  '/_protected/sync/$syncId': typeof ProtectedSyncSyncIdLazyRoute
  '/_protected/sync/orders': typeof ProtectedSyncOrdersLazyRoute
  '/_protected/sync/': typeof ProtectedSyncIndexLazyRoute
  '/_protected/sync/category/$categoryId': typeof ProtectedSyncCategoryCategoryIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/guide'
    | '/settings'
    | '/sync/$syncId'
    | '/sync/orders'
    | '/sync'
    | '/sync/category/$categoryId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/guide'
    | '/settings'
    | '/sync/$syncId'
    | '/sync/orders'
    | '/sync'
    | '/sync/category/$categoryId'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/_protected/guide'
    | '/_protected/settings'
    | '/_protected/sync/$syncId'
    | '/_protected/sync/orders'
    | '/_protected/sync/'
    | '/_protected/sync/category/$categoryId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_protected"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_protected": {
      "filePath": "_protected.tsx",
      "children": [
        "/_protected/guide",
        "/_protected/settings",
        "/_protected/sync/$syncId",
        "/_protected/sync/orders",
        "/_protected/sync/",
        "/_protected/sync/category/$categoryId"
      ]
    },
    "/_protected/guide": {
      "filePath": "_protected/guide.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/settings": {
      "filePath": "_protected/settings.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/sync/$syncId": {
      "filePath": "_protected/sync/$syncId.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/sync/orders": {
      "filePath": "_protected/sync/orders.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/sync/": {
      "filePath": "_protected/sync/index.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/sync/category/$categoryId": {
      "filePath": "_protected/sync/category/$categoryId.lazy.tsx",
      "parent": "/_protected"
    }
  }
}
ROUTE_MANIFEST_END */
